export default "__VITE_ASSET__D1cQiEU8__"